// extracted by mini-css-extract-plugin
module.exports = {"SearchBarWrapper":"searchbar_SearchBarWrapper__3h8Lh"};